import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { TranslateService } from "@ngx-translate/core";
import { BFXNotificationType } from "../../../shared/cubiq-services/model/core/notifications/BFXNotificationType";
import { BFXNotificationSubType } from "../../../shared/cubiq-services/model/core/notifications/BFXNotificationSubType";

export enum PROFILE_TYPE {
  USER_PROFILE,
  BLOTTER_LAYOUT,
  USER_PROFILE_PUBLIC,
}

@Injectable()
export class BfxSaveProfileNotificationService {
  /**********************************************************************/
  /* DATA */

  // notifications
  private notificationEventSource = new Subject<any>();
  public notifyCtrl$ = this.notificationEventSource.asObservable();
  // footer message
  private footerMsgEventSource = new Subject<any>();
  public footerCtrl$ = this.footerMsgEventSource.asObservable();

  /**********************************************************************/
  /* CONSTRUCTOR  */

  constructor(private _translate: TranslateService) {}

  /**********************************************************************/
  /* POPUP NOTIFICATIONS  */
  public notifyFailureWithPopup(type: PROFILE_TYPE = PROFILE_TYPE.USER_PROFILE): void {
    if (type != null && type === PROFILE_TYPE.BLOTTER_LAYOUT) {
      this.notifyWithPopup(
        BFXNotificationType.PROFILE,
        BFXNotificationSubType.SAVE_BLOTTER_LAYOUT_FAIL,
      );
    } else {
      this.notifyWithPopup(
        BFXNotificationType.PROFILE,
        BFXNotificationSubType.SAVE_USER_PROFILE_FAIL,
      );
    }
  }

  public notifySuccessWithPopup(type: PROFILE_TYPE = PROFILE_TYPE.USER_PROFILE): void {
    if (type != null && type === PROFILE_TYPE.BLOTTER_LAYOUT) {
      this.notifyWithPopup(
        BFXNotificationType.PROFILE,
        BFXNotificationSubType.SAVE_BLOTTER_LAYOUT_SUCCESS,
      );
    } else {
      this.notifyWithPopup(
        BFXNotificationType.PROFILE,
        BFXNotificationSubType.SAVE_USER_PROFILE_SUCCESS,
      );
    }
  }

  public notifyWithPopup(
    notificationType: BFXNotificationType,
    notificationSubType: BFXNotificationSubType,
    message: string = null,
  ): void {
    this.notificationEventSource.next({
      type: notificationType,
      subType: notificationSubType,
      message: message,
    });
  }

  /**********************************************************************/
  /* FOOTER MESSAGE NOTIFICATIONS  */

  public notifySuccessOnFooter(type: PROFILE_TYPE = PROFILE_TYPE.USER_PROFILE): void {
    try {
      let message: string = null;
      if (type != null && type === PROFILE_TYPE.BLOTTER_LAYOUT) {
        message = this._translate.instant("footer.notification.blotter_layout_save_success");
      } else if (type != null && type === PROFILE_TYPE.USER_PROFILE_PUBLIC) {
        message = this._translate.instant("footer.notification.public_profile_save_success");
      } else {
        message = this._translate.instant("footer.notification.profile_save_success");
      }
      this.notifyOnFooter(message);
    } catch (ex) {
      logger.out.error(`EXCEPTION: userProfile.notifySuccessOnFooter(): %O`, ex);
    }
  }

  public notifyFailureOnFooter(type: PROFILE_TYPE = PROFILE_TYPE.USER_PROFILE): void {
    try {
      let message: string = null;
      if (type != null && type === PROFILE_TYPE.BLOTTER_LAYOUT) {
        message = this._translate.instant("footer.notification.blotter_layout_save_fail");
      } else if (type != null && type === PROFILE_TYPE.USER_PROFILE_PUBLIC) {
        message = this._translate.instant("footer.notification.public_profile_save_fail");
      } else {
        message = this._translate.instant("footer.notification.profile_save_fail");
      }
      this.notifyOnFooter(message);
    } catch (ex) {
      logger.out.error(`EXCEPTION: userProfile.notifySuccessOnFooter(): %O`, ex);
    }
  }

  public notifyOnFooter(message: string): void {
    this.footerMsgEventSource.next(message);
  }
}
